<div body>
  <div fxLayout="row" fxLayoutAlign="center stretch">

    <div fxFlex="35%">
      <div class="section-content">
        <mat-card class="generalInfo">
          <mat-card-header class="chartMatHeader">
            <mat-card-title>
              <div style="float: left;">
                <span class="card-title-text"> Daily Totals </span>
                <button mat-raised-button color="primary" class="btnShowTable" (click)="showTable('daily')">{{dailyChartBtnText}}</button>
              </div>
              <!-- <div style="float: right;">
                <button>
                  <mat-icon>fullscreen</mat-icon>
                </button>
              </div> -->
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <ng-container *ngIf="!showDailyStatsTable; else dailyStatsTemplate">
              <highcharts-chart id="dailyChartId" [Highcharts]="dailyHighcharts" [options]="dailyChartOptions"
                [(update)]="isDailyChartUpdated" [oneToOne]="true" >
              </highcharts-chart>
            </ng-container>
            <ng-template #dailyStatsTemplate>
              <ejs-grid [dataSource]="dailyStatisticsList" allowTextWrap='true'>
                <e-columns>
                  <e-column field='labName' headerText='Lab Name' textAlign='Center' width=100></e-column>
                  <e-column field='numberOfPCRCases' headerText='PCR Cases' textAlign='Center' width=30></e-column>
                  <e-column field='numberOfPGXCases' headerText='PGX Cases' textAlign='Center' width=30></e-column>
                  <e-column field='numberOfOralCases' headerText='Oral Cases' textAlign='Center' width=30></e-column>
                  <e-column field='numberOfUrineCases' headerText='Urine Cases' textAlign='Center' width=30></e-column>
                  <e-column field='numberOfBloodCases' headerText='Blood Cases' textAlign='Center' width=30></e-column>
                </e-columns>
              </ejs-grid>
            </ng-template>
          </mat-card-content>
        </mat-card>
      </div>
    </div>

    <div fxFlex="35%">
      <div class="section-content">
        <mat-card class="generalInfo">
          <mat-card-header class="chartMatHeader">
            <mat-card-title>
              <div style="float: left;">
                <span class="card-title-text"> Monthly Totals </span>
                <button mat-raised-button color="primary" class="btnShowTable" (click)="showTable('monthly')">{{monthlyChartBtnText}}</button>
              </div>
              <!-- <div style="float: right;">
                <button style="margin-top: -7px;">
                  <mat-icon>fullscreen</mat-icon>
                </button>
              </div> -->
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <ng-container *ngIf="!showMonthlyStatsTable">
              <highcharts-chart id="monthlyChart" [Highcharts]="montlyHighcharts" [options]="monthlyChartOptions"
                [(update)]="isMonthlyChartUpdated" [oneToOne]="true">
              </highcharts-chart>
            </ng-container>
            <ng-container *ngIf="showMonthlyStatsTable">
              <ejs-grid [dataSource]="monthlyStatisticsList" allowTextWrap='true'>
                <e-columns>
                  <e-column field='labName' headerText='Lab Name' textAlign='Center' width=100></e-column>
                  <e-column field='numberOfPCRCases' headerText='PCR Cases' textAlign='Center' width=30></e-column>
                  <e-column field='numberOfPGXCases' headerText='PGX Cases' textAlign='Center' width=30></e-column>
                  <e-column field='numberOfOralCases' headerText='Oral Cases' textAlign='Center' width=30></e-column>
                  <e-column field='numberOfUrineCases' headerText='Urine Cases' textAlign='Center' width=30></e-column>
                  <e-column field='numberOfBloodCases' headerText='Blood Cases' textAlign='Center' width=30></e-column>
                </e-columns>
              </ejs-grid>
            </ng-container>
          </mat-card-content>
        </mat-card>
      </div>
    </div>

  </div>

  <div fxLayout="row" fxLayoutAlign="center stretch">
    
    <div fxFlex="70%">
      <div class="section-content">
        <mat-card class="generalInfo">
          <mat-card-header class="chartMatHeader">
            <mat-card-title>
              <div style="float: left;">
                <span class="card-title-text"> Lab Notifications </span>
              </div>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <ng-container>
              <ejs-grid [dataSource]="labNotificationList" allowTextWrap='true'>
                <e-columns>
                  <e-column field='message' headerText='Message'></e-column>
                </e-columns>
              </ejs-grid>
            </ng-container>
          </mat-card-content>
        </mat-card>
      </div>
    </div>

    <!-- <div fxFlex="35%">
    </div> -->

  </div>
  
</div>